import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';
import { copyToClipboard } from '../../../utils/clipboard';

export default function CodeBlock({ children }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        copyToClipboard(children);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    return (
        <Box sx={{ position: 'relative', my: 1 }}>
            <IconButton
                size="small"
                onClick={handleCopy}
                sx={{ position: 'absolute', top: 4, right: 4, color: 'grey.500' }}
            >
                {copied ? <Check fontSize="small" color="success" /> : <ContentCopy fontSize="small" />}
            </IconButton>
            <Box
                component="pre"
                sx={{
                    bgcolor: 'grey.100', p: 2, pr: 5, borderRadius: 1,
                    overflow: 'auto', fontFamily: 'monospace', fontSize: '0.8rem',
                    whiteSpace: 'pre-wrap', wordBreak: 'break-all',
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
